import api from "!../../../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../node_modules/css-loader/dist/cjs.js!../../../../../node_modules/vue-loader-v3/dist/stylePostLoader.js!../../../../../node_modules/vue-loader-v3/dist/index.js??ruleSet[1].rules[6].use[0]!./PhoneInput.vue?vue&type=style&index=0&id=acbb7f6c&lang=css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};